import { cva, type VariantProps } from "class-variance-authority";
import type { ButtonHTMLAttributes } from "react";

import { cn } from "@/lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center rounded-[var(--button-radius)] border border-transparent px-4 py-3 text-center text-xs font-semibold uppercase leading-tight tracking-[0.14em] transition-[transform,background-color,border-color,color,box-shadow,opacity] duration-300 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 motion-safe:hover:-translate-y-0.5 motion-safe:hover:shadow-[0_16px_30px_-18px_hsl(var(--shadow-strength)/0.45)] sm:px-5 sm:text-sm sm:tracking-[0.18em]",
  {
    variants: {
      variant: {
        primary: "bg-primary text-primary-foreground hover:bg-primary/92",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/90",
        outline:
          "border-border bg-transparent text-foreground hover:border-accent hover:text-foreground",
        ghost: "bg-transparent text-foreground hover:bg-primary/5",
      },
      size: {
        default: "min-h-11 sm:min-h-12",
        compact: "min-h-10 px-3 py-2 sm:px-4",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "default",
    },
  },
);

export { buttonVariants };

export interface ButtonProps
  extends
    ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

export function Button({
  className,
  size,
  variant,
  ...props
}: ButtonProps): JSX.Element {
  return (
    <button
      className={cn(buttonVariants({ className, size, variant }))}
      {...props}
    />
  );
}
